var _ = require("underscore");

localStorage.setItem(
  "shoppingCart",
  localStorage.getItem("shoppingCart")
    ? localStorage.getItem("shoppingCart")
    : JSON.stringify([])
);
const addProduct = function(product) {
  let shoppingCart = [];
  let pushCart = true;
  if (product.quantity > 0) {
    shoppingCart = JSON.parse(localStorage.getItem("shoppingCart"));
    shoppingCart.forEach((item) => {
      if (product.id === item.id) {
        item.quantity = parseInt(item.quantity) + parseInt(product.quantity);
        pushCart = false;
      }
    });
    if (pushCart) {
      shoppingCart.push(product);
    }
    localStorage.setItem("shoppingCart", JSON.stringify(shoppingCart));
  } else {
    return false;
  }
};
const removeProduct = function(productId) {
  let shoppingCart = [];
  let shoppingCartFilter = [];
  shoppingCart = JSON.parse(localStorage.getItem("shoppingCart"));
  shoppingCartFilter = _.filter(shoppingCart, function(item) {
    return item.id != productId;
  });

  localStorage.setItem("shoppingCart", JSON.stringify(shoppingCartFilter));
};

const updateProduct = function(product) {
  let shoppingCart = [];
  shoppingCart = JSON.parse(localStorage.getItem("shoppingCart"));
  shoppingCart.forEach((item) => {
    if (product.id === item.id) {
      item.quantity = product.quantity;
    }
  });
  localStorage.setItem("shoppingCart", JSON.stringify(shoppingCart));
};
const getImageURL = function(link, name) {
  var image = name.split(" ").join("+");
  return link + image;
};

exports.addProductCart = addProduct;
exports.removeProductCart = removeProduct;
exports.updateProductCart = updateProduct;
exports.getImageURL = getImageURL;
